"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ScenerySmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.9068667,6.2093809 L15.9068667,13.2093809 C16.1377398,13.4785837 15.9425139,14 15.5,14 L2.5,14 C2.12462826,14 1.84075693,13.5636166 2.09038404,13.2132688 L5.59038404,8.21326883 C5.74874129,7.98704418 6.13896236,7.88852561 6.4,8.2 L7.5,9.66666667 L10.1,6.2 C10.2959125,5.92426415 10.6971693,5.92426415 10.9068667,6.2093809 Z M10.4901588,7.34645489 L7.5,11.3333333 L6.01396265,9.35195019 L3.46032778,13 L14.5284053,13 L10.4901588,7.34645489 Z M6,4 C6.55228475,4 7,4.44771525 7,5 C7,5.55228475 6.55228475,6 6,6 C5.44771525,6 5,5.55228475 5,5 C5,4.44771525 5.44771525,4 6,4 Z" })));
};
ScenerySmall.displayName = 'ScenerySmall';
exports.default = ScenerySmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ScenerySmall.js.map